module.exports = __webpack_public_path__ + "static/img/t11.00348378.png";